import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ChildrenBlock, useEditor, useChildrenBlocks } from '@smartfire/js-block-engine'
import style from './style.module.scss'
import clsx from 'clsx'

const ProfileMenuMainHeader = () => {
    const { t } = useTranslation()
    const { children, Child } = useChildrenBlocks()
    const [childActive, setChildActive] = useState(null)
    const { isEditing } = useEditor()

    const containerClasses = clsx({
        [style.container]: true,
        [style.admin]: isEditing,
    })

    return (
        <div className={containerClasses}>
            <div className={style.content}>
                <div className={style.head}>{t('Qui êtes-vous ?')}</div>
                {isEditing ? (
                    <ChildrenBlock
                        gutenbergEditorConfig={{
                            allowedBlocks: ['smartfire/header---main---menu---profile---item'],
                            template: [
                                ['smartfire/header---main---menu---profile---item'],
                                ['smartfire/header---main---menu---profile---item'],
                                ['smartfire/header---main---menu---profile---item'],
                                ['smartfire/header---main---menu---profile---item'],
                                ['smartfire/header---main---menu---profile---item'],
                            ],
                        }}
                        className={style.grid}
                    />
                ) : (
                    <div className={style.grid}>
                        {children.map((_, index) => {
                            return (
                                <Child
                                    key={index}
                                    number={index}
                                    index={index}
                                    setActive={setChildActive}
                                    active={index === childActive}
                                />
                            )
                        })}
                    </div>
                )}
            </div>
        </div>
    )
}

export default ProfileMenuMainHeader
